import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

export const Logo = styled.img`
  display: block;
  height: ${rem(24)};
  width: auto;
`;
